var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import Loader from '@/components/UI/Loader';
const SelectCombatMapModal = (_a) => {
    var { isOpen, onRequestClose, closeTimeoutMS = 200, contentLabel = '', className = 'combat-map-modal', overlayClassName = 'combat-map-modal-overlay', combatMapsLoading, combatMaps, handleSelectCombatMap, room } = _a, rest = __rest(_a, ["isOpen", "onRequestClose", "closeTimeoutMS", "contentLabel", "className", "overlayClassName", "combatMapsLoading", "combatMaps", "handleSelectCombatMap", "room"]);
    const { t } = useTranslation();
    const mapIsActive = (map) => {
        var _a;
        if (room) {
            return ((_a = map.room) === null || _a === void 0 ? void 0 : _a.id) === room.id;
        }
        return map.isActive;
    };
    return (_jsx(ReactModal, Object.assign({ isOpen: isOpen, onRequestClose: onRequestClose, closeTimeoutMS: closeTimeoutMS, contentLabel: contentLabel, className: className, overlayClassName: overlayClassName }, rest, { children: combatMapsLoading ? (_jsx(Loader, {})) : (_jsxs(_Fragment, { children: [_jsx("h2", { children: contentLabel }), _jsxs("div", { className: "combat-maps-list", children: [_jsx("ul", { children: combatMaps.map((map) => (_jsx("li", { children: _jsx("button", { className: mapIsActive(map) ? 'active' : '', onClick: () => handleSelectCombatMap(map), children: _jsx("span", { children: map.name }) }) }, map.id))) }), _jsx("button", { onClick: onRequestClose, children: t('common.close') })] })] })) })));
};
export default SelectCombatMapModal;
